var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkCircled = function SvgCheckmarkCircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.333 3.317-9.508 9.516L4.29 9.3l1.175-1.175 2.359 2.358 8.333-8.333 1.175 1.167Zm-1.841 4.2c.108.475.174.975.174 1.483A6.665 6.665 0 0 1 9 15.667 6.665 6.665 0 0 1 2.333 9 6.665 6.665 0 0 1 9 2.333a6.6 6.6 0 0 1 3.566 1.042l1.2-1.2A8.25 8.25 0 0 0 9 .667 8.336 8.336 0 0 0 .667 9c0 4.6 3.733 8.333 8.333 8.333S17.333 13.6 17.333 9c0-.992-.183-1.942-.5-2.825l-1.341 1.342Z",
    fill: "#D6580F"
  })));
};

export default SvgCheckmarkCircled;